import React from 'react';
import './Download.css';
import { trackDownload } from '../utils/analytics';

const Download: React.FC = () => {
  const handleAppStoreClick = () => {
    // Track App Store click
    trackDownload('ios');
    // Replace with actual App Store URL when available
    window.open('https://apps.apple.com/app/choretap', '_blank');
  };

  const handlePlayStoreClick = () => {
    // Track Play Store click
    trackDownload('android');
    // Replace with actual Play Store URL when available
    window.open('https://play.google.com/store/apps/details?id=com.choretap', '_blank');
  };

  return (
    <section id="download" className="download section">
      <div className="download-background">
        <div className="download-shape download-shape-1"></div>
        <div className="download-shape download-shape-2"></div>
      </div>

      <div className="container">
        <div className="download-content">
          <div className="download-text">
            <h2>Ready to Transform Your Family's Chore Experience?</h2>
            <p>
              Join thousands of families who have made chores fun, organized, and rewarding
              with ChoreTap. Download now and start your journey to a more harmonious household.
            </p>

            {/*<div className="download-stats">*/}
            {/*  <div className="stat-item">*/}
            {/*    <span className="stat-number">10K+</span>*/}
            {/*    <span className="stat-label">Happy Families</span>*/}
            {/*  </div>*/}
            {/*  <div className="stat-item">*/}
            {/*    <span className="stat-number">4.8★</span>*/}
            {/*    <span className="stat-label">App Rating</span>*/}
            {/*  </div>*/}
            {/*  <div className="stat-item">*/}
            {/*    <span className="stat-number">50K+</span>*/}
            {/*    <span className="stat-label">Chores Completed</span>*/}
            {/*  </div>*/}
            {/*</div>*/}
          </div>

          <div className="download-buttons">
            <h3>Download ChoreTap Now</h3>
            <div className="store-buttons">
              <button onClick={handleAppStoreClick} className="store-button ios">
                <div className="store-icon">
                  <svg viewBox="0 0 24 24" width="28" height="28">
                    <path fill="currentColor" d="M18.71,19.5c-0.83,1.24-1.71,2.45-3.05,2.47c-1.34,0.03-1.77-0.79-3.29-0.79c-1.53,0-2,0.77-3.27,0.82c-1.31,0.05-2.3-1.32-3.14-2.53C4.25,17,2.94,12.45,4.7,9.39c0.87-1.52,2.43-2.48,4.12-2.51c1.28-0.02,2.5,0.87,3.29,0.87c0.78,0,2.26-1.07,3.81-0.91c0.65,0.07,2.47,0.26,3.64,1.98c-0.09,0.06-2.17,1.28-2.15,3.81c0.03,3.02,2.65,4.03,2.68,4.04C19.85,16.6,19.49,18.98,18.71,19.5z M13,3.5c0.73-0.83,1.94-1.46,2.94-1.5c0.13,1.17-0.34,2.35-1.04,3.19c-0.69,0.85-1.83,1.51-2.95,1.42C11.81,5.77,12.3,4.61,13,3.5z"/>
                  </svg>
                </div>
                <div className="store-text">
                  <span className="store-subtitle">Download on the</span>
                  <span className="store-title">App Store</span>
                </div>
              </button>

              <button onClick={handlePlayStoreClick} className="store-button android">
                <div className="store-icon">
                  <svg viewBox="0 0 24 24" width="28" height="28">
                    <path fill="currentColor" d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z"/>
                  </svg>
                </div>
                <div className="store-text">
                  <span className="store-subtitle">Get it on</span>
                  <span className="store-title">Google Play</span>
                </div>
              </button>
            </div>

            <div className="beta-signup">
              <div className="beta-badge">🎉 Beta Program</div>
              <h4>Join Our Beta Testing Program</h4>
              <p>Be among the first families to experience ChoreTap! Get early access, exclusive features, and help shape the future of our app.</p>
              <a href="mailto:support@choretap.app?subject=Beta Program Interest&body=I%20am%20interested%20in%20joining%20the%20beta!%20Sign%20me%20up!" className="btn btn-primary btn-beta">
                📧 Email to Join Beta
              </a>
              <p className="beta-email">Or email us at: <strong>support@choretap.app</strong></p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Download;
